const mockNavComparison = {
    "Investments at Fair Value": {
      "31/12/2024": 698400000.0,
      "30/09/2024": 485620000.0,
      "change": 212780000.0,
      "changePercent": 0.4382,
 
    },
    "Private Equity Investments - Equity": {
      "31/12/2024": 523800000.0,
      "30/09/2024": 364215000.0,
      "change": 159585000.0,
      "changePercent": 0.4382,
 
    },
    "Private Equity Investments - Debt": {
      "31/12/2024": 174600000.0,
      "30/09/2024": 121405000.0,
      "change": 53195000.0,
      "changePercent": 0.8764,
 
    },
    "Cash and Cash Equivalents": {
      "31/12/2024": 76751499.0,
      "30/09/2024": 42350860.0,
      "change": 34400639.0,
      "changePercent": 0.8123,
 
    },
    "Cash at Bank": {
      "31/12/2024": 35780500.0,
      "30/09/2024": 20250400.0,
      "change": 15530100.0,
      "changePercent": 0.7669,
 
    },
    "Money Market Funds": {
      "31/12/2024": 26781520.0,
      "30/09/2024": 14325670.0,
      "change": 12455850.0,
      "changePercent": 0.8695,
 
    },
    "Short-term Deposits": {
      "31/12/2024": 14189479.0,
      "30/09/2024": 7774790.0,
      "change": 6414689.0,
      "changePercent": 0.8251,
 
    },
    "Receivables": {
      "31/12/2024": 7540652.0,
      "30/09/2024": 4850300.0,
      "change": 2690352.0,
      "changePercent": 1.1094,
 
    },
    "Dividend Receivables": {
      "31/12/2024": 975480.0,
      "30/09/2024": 520300.0,
      "change": 455180.0,
      "changePercent": 0.8748,
 
    },
    "Interest Receivables": {
      "31/12/2024": 2675326.0,
      "30/09/2024": 1650200.0,
      "change": 1025126.0,
      "changePercent": 0.6212,
 
    },
    "Management Fee Rebates": {
      "31/12/2024": 695831.0,
      "30/09/2024": 480600.0,
      "change": 215231.0,
      "changePercent": 0.4478,
 
    },
    "Other Receivables": {
      "31/12/2024": 3194015.0,
      "30/09/2024": 2199200.0,
      "change": 994815.0,
      "changePercent": 0.4524,
 
    },
    "Prepaid Expenses": {
      "31/12/2024": 510940.0,
      "30/09/2024": 375600.0,
      "change": 135340.0,
      "changePercent": 0.7206,
 
    },
    "Insurance Prepayments": {
      "31/12/2024": 142670.0,
      "30/09/2024": 95300.0,
      "change": 47370.0,
      "changePercent": 0.4971,
 
    },
    "Other Prepaid Expenses": {
      "31/12/2024": 368270.0,
      "30/09/2024": 280300.0,
      "change": 87970.0,
      "changePercent": 0.3138,
 
    },
    "Other Assets": {
      "31/12/2024": 2084430.0,
      "30/09/2024": 1475200.0,
      "change": 609230.0,
      "changePercent": 0.413,
 
    },
    "Tax Reclaims": {
      "31/12/2024": 687255.0,
      "30/09/2024": 485300.0,
      "change": 201955.0,
      "changePercent": 0.4161,
 
    },
    "Deferred Costs": {
      "31/12/2024": 982175.0,
      "30/09/2024": 675400.0,
      "change": 306775.0,
      "changePercent": 0.9084,
 
    },
    "Sundry Assets": {
      "31/12/2024": 415000.0,
      "30/09/2024": 314500.0,
      "change": 100500.0,
      "changePercent": 0.3196,
 
    },
    "TOTAL ASSETS": {
      "31/12/2024": 2355862563.0,
      "30/09/2024": null,
      "change": null,
      "changePercent": null,
 
    },
    "Management Fee Payable": {
      "31/12/2024": 3926438.0,
      "30/09/2024": 2285750.0,
      "change": 1640688.0,
      "changePercent": 1.4356,
 
    },
    "Performance Fees Payable": {
      "31/12/2024": 44635734.0,
      "30/09/2024": 18750000.0,
      "change": 25885734.0,
      "changePercent": 1.3806,
 
    },
    "Realized Performance Fees": {
      "31/12/2024": 12654910.0,
      "30/09/2024": 5230000.0,
      "change": 7424910.0,
      "changePercent": 1.4197,
 
    },
    "Unrealized Performance Fees": {
      "31/12/2024": 31980824.0,
      "30/09/2024": 13520000.0,
      "change": 18460824.0,
      "changePercent": 1.3654,
 
    },
    "Subscriptions in Advance": {
      "31/12/2024": 18319805.0,
      "30/09/2024": 12420350.0,
      "change": 5899455.0,
      "changePercent": 0.475,
 
    },
    "Accrued Expenses": {
      "31/12/2024": 1660218.0,
      "30/09/2024": 1215860.0,
      "change": 444358.0,
      "changePercent": 0.731,
 
    },
    "Audit Fees": {
      "31/12/2024": 320450.0,
      "30/09/2024": 215300.0,
      "change": 105150.0,
      "changePercent": 0.4884,
 
    },
    "Legal Fees": {
      "31/12/2024": 487234.0,
      "30/09/2024": 345670.0,
      "change": 141564.0,
      "changePercent": 0.4095,
 
    },
    "Administration Fees": {
      "31/12/2024": 305620.0,
      "30/09/2024": 215400.0,
      "change": 90220.0,
      "changePercent": 0.4188,
 
    },
    "Custody Fees": {
      "31/12/2024": 196500.0,
      "30/09/2024": 132750.0,
      "change": 63750.0,
      "changePercent": 0.4802,
 
    },
    "Directors' Fees": {
      "31/12/2024": 78500.0,
      "30/09/2024": 54300.0,
      "change": 24200.0,
      "changePercent": 0.8914,
 
    },
    "Regulatory Fees": {
      "31/12/2024": 84764.0,
      "30/09/2024": 60440.0,
      "change": 24324.0,
      "changePercent": 0.4024,
 
    },
    "Other Accrued Expenses": {
      "31/12/2024": 187150.0,
      "30/09/2024": 192000.0,
      "change": -4850.0,
      "changePercent": -0.0253,
    }
  };
  
  export default mockNavComparison;